export const ROLE = 'community'
export const MAX_DEPOSIT_FALLBACK = 100000000000
export const MIN_DEPOSIT_FALLBACK = 0.000001
export const MAX_DECIMALS_FALLBACK = 6

export const MAX_WITHDRAW_FALLBACK = 0
export const MIN_WITHDRAW_FALLBACK = MIN_DEPOSIT_FALLBACK
